// extracted by mini-css-extract-plugin
export default {"hazardous":"CommodityCode_hazardous__-ZoDM"};